var exports = {
  "n$": "popoverWrapper__H_KykV",
  "Lw": "overlay__8lx0Xf",
  "DD": "title__VFp8yU",
  "qr": "elapsedTime__xSMDIx",
  "nL": "taskItemRow__f2DZ2J",
  "rK": "taskItem__z4GY0k",
  "x2": "popoverContainer__4vZHBQ",
  "ig": "taskList__og53QC",
  "MK": "kebabButton__wgXpYL",
  "RV": "bottomLeft__XMidPu",
  "oF": "bottomRight__vmci4Y",
};

module.exports = exports;
